export function getInputMetadata(invalid: boolean | undefined): any {
  return invalid ? { 'data-meta-invalid': 1 } : {};
}
